// Top stat cards (Active Domains / Total Calls / Customer Domains).
import React from 'react';

export const StatCard = ({ icon: Icon, label, value, color, testId, onClick }) => (
  <div
    data-testid={testId}
    className={`bg-white/5 border border-white/10 rounded-xl p-5 transition-all ${
      onClick ? 'cursor-pointer hover:bg-white/10 hover:border-teal-500/30 group' : ''
    }`}
    onClick={onClick}
  >
    <div className={`inline-flex p-2 rounded-lg mb-3 ${color}`}>
      <Icon className="w-5 h-5 text-white" />
    </div>
    <p className={`text-3xl font-bold text-white ${onClick ? 'group-hover:text-teal-300 transition-colors' : ''}`}>
      {value}
    </p>
    <p className="text-white/40 text-sm mt-1">
      {label}{onClick && <span className="text-teal-500/70 ml-1">→</span>}
    </p>
  </div>
);
